import api from './api';

const DBNOMICS_BASE_URL = 'https://api.db.nomics.world/v22';

class IndicatorService {
  // ISM 제조업 PMI 지수 가져오기
  async getISMPMI() {
    try {
      const response = await fetch(
        `${DBNOMICS_BASE_URL}/series/ISM/pmi?facets=1&format=json&limit=1000&observations=1`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.series && data.series.docs && data.series.docs.length > 0) {
        const seriesData = data.series.docs[0];
        
        // 데이터를 차트에 사용할 수 있는 형태로 변환
        const chartData = seriesData.period.map((period, index) => ({
          date: period,
          value: seriesData.value[index],
          period_start: seriesData.period_start_day[index]
        }));
        
        return {
          name: seriesData.series_name,
          dataset_name: seriesData.dataset_name,
          provider: data.provider.name,
          data: chartData,
          latest_value: seriesData.value[seriesData.value.length - 1],
          latest_period: seriesData.period[seriesData.period.length - 1]
        };
      }
      
      throw new Error('No data found');
    } catch (error) {
      console.error('Error fetching ISM PMI data:', error);
      throw error;
    }
  }

  // 향후 다른 경제 지표들을 추가할 수 있는 구조
  async getEconomicIndicator(provider, dataset, series = null) {
    try {
      let url = `${DBNOMICS_BASE_URL}/series/${provider}/${dataset}`;
      if (series) {
        url += `/${series}`;
      }
      url += '?facets=1&format=json&limit=1000&observations=1';
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching economic indicator:', error);
      throw error;
    }
  }

  // CNN Fear and Greed Index 가져오기
  async getFearAndGreedIndex(params = {}) {
    try {
      const { date_from, date_to, limit = 365 } = params;
      
      const queryParams = new URLSearchParams();
      if (date_from) queryParams.append('date_from', date_from);
      if (date_to) queryParams.append('date_to', date_to);
      if (limit) queryParams.append('limit', limit);
      
      const response = await api.get(`/api/data_predator/fear-greed-index/?${queryParams.toString()}`);
      
      if (response.data) {
        return {
          latest: response.data.latest,
          data: response.data.data,
          count: response.data.count
        };
      }
      
      throw new Error('No data found');
    } catch (error) {
      console.error('Error fetching Fear and Greed Index:', error);
      throw error;
    }
  }

  // Fear and Greed Index 통계 가져오기
  async getFearAndGreedStats() {
    try {
      const response = await api.get('/api/data_predator/fear-greed-index/stats/');
      return response.data;
    } catch (error) {
      console.error('Error fetching Fear and Greed Index stats:', error);
      throw error;
    }
  }

  // Fear and Greed Index 데이터 수집 트리거
  async fetchFearAndGreedData(fetchType = 'current') {
    try {
      const response = await api.post('/api/data_predator/fear-greed-index/', {
        fetch_type: fetchType
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Fear and Greed Index data:', error);
      throw error;
    }
  }
}

export default new IndicatorService();
